import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45e7c14a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ScheduleAdd" }
const _hoisted_2 = { class: "form-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-color" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "施工现场进度概述")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "图片")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-box" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_10 = { class: "submit-btn" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { uploadFileItem } from '@/apis/base'
import dayjs from 'dayjs'
import { onMounted, reactive, ref, watch } from 'vue'
import SimpImageUpload from '@/components/SimpImageUpload.vue'
import { saveProject, ProgressSave } from '@/apis/schedule'
import { Toast } from 'vant'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const formatDate = date => {
  return `${dayjs(date).format('YYYY-MM-DD HH:mm')}`
}
const state = reactive({
  name: '',
  formData: {} as saveProject
})

const maxDate = ref(new Date(dayjs().format('YYYY-MM-DD HH:mm')))

const router = useRouter()
const currentDate = ref(new Date(dayjs().format('YYYY-MM-DD HH:mm')))

const EndshowPicker = ref(false)

const fileList = ref<Array<uploadFileItem>>([])
watch(fileList, (newVal, oldVal) => {
  console.log('ticket add fileList ===>', newVal)
  // data.saveData.upload_file_list = newVal
  state.formData.pics = newVal
})

const onEndConfirm = data => {
  console.log(formatDate(data))
  state.formData.patrol_time = formatDate(data)
  EndshowPicker.value = false
}

const onSubmit = async () => {
  const res = await ProgressSave(state.formData)
  if (res.code == 200) {
    console.log(res.data)
    Toast.success({
      message: res.msg,
      duration: 500,
      onClose: () => {
        router.back()
      }
    })
  } else {
    Toast(res.msg)
  }
}

const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})

onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  StaffInfo.value.currentTime = dayjs().format('YYYY-MM-DD HH:mm')
  state.formData.project_id = router.currentRoute.value.query.project_id.toString()
  state.name = router.currentRoute.value.query.project_name.toString()
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_common_info = _resolveComponent("common-info")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_bottom_button = _resolveComponent("bottom-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_form, { onSubmit: onSubmit }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_cell, {
                title: "项目名称",
                value: _unref(state).name
              }, null, 8, ["value"]),
              _hoisted_3,
              _createVNode(_component_van_field, {
                label: "巡查时间",
                modelValue: _unref(state).formData.patrol_time,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).formData.patrol_time) = $event)),
                "input-align": "right",
                "is-link": "",
                readonly: "",
                name: "picker",
                placeholder: "请选择",
                required: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (EndshowPicker.value = true))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_popup, {
                show: EndshowPicker.value,
                "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((EndshowPicker).value = $event)),
                position: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_datetime_picker, {
                    modelValue: currentDate.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentDate).value = $event)),
                    type: "datetime",
                    title: "选择日期",
                    onConfirm: onEndConfirm,
                    onCancel: _cache[3] || (_cache[3] = ($event: any) => (EndshowPicker.value = false))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["show"]),
              _createVNode(_component_van_cell, { title: "施工现场进度概述" }, {
                title: _withCtx(() => [
                  _hoisted_4
                ]),
                label: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: _unref(state).formData.explain,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).formData.explain) = $event)),
                    rows: "2",
                    autosize: "",
                    type: "textarea",
                    placeholder: "请输入施工现场进度概述",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_5,
              _createVNode(_component_van_cell, null, {
                title: _withCtx(() => [
                  _hoisted_6
                ]),
                label: _withCtx(() => [
                  _createVNode(SimpImageUpload, {
                    isShowTitle: false,
                    modelValue: fileList.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((fileList).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_7,
              _hoisted_8,
              _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"]),
              _hoisted_9
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_bottom_button, {
              round: "",
              block: "",
              type: "primary",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})